"use client"
import { useState } from "react"
import { cancelMembership } from "../../services/membership/MembershipAxios"
import toast from "react-hot-toast"
import { X } from "lucide-react"
import { useAuth } from "../../context/AuthContext"
import { dictionary } from "../../utils/dictionary"

interface FeedbackModalProps {
  isOpen: boolean
  onClose: () => void
}

export function FeedbackModal({ isOpen, onClose }: FeedbackModalProps) {
  const [feedback, setFeedback] = useState("")
  const { language } = useAuth();
  const minLength = 30

  if (!isOpen) return null

  const handleCancel = () => {
    if (feedback.length < minLength) {
      toast.error(dictionary["the-feedback-must-have-at-least"][language] + minLength + dictionary["characters"][language])
      return
    }
    cancelMembership(feedback)
      .then(() => {
        onClose()
        toast.success(dictionary["your-subscription-has-been-canceled"][language])
        window.location.reload();
      })
      .catch((error) => {
        toast.error(dictionary["error-canceling-subscription"][language])
        console.error(error)
      })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative bg-white rounded-3xl shadow-lg w-full max-w-md mx-4 p-6">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
          <X className="w-5 h-5" />
        </button>

        <div className="space-y-6">
          <h2 className="text-xl font-semibold text-gray-900">{dictionary["understood"][language]}.</h2>

          <p className="text-gray-600">
            {dictionary["please-tell-us-the-real-reason-for-your-cancellation"][language]}
          </p>

          <div className="space-y-2">
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-3 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              placeholder={dictionary["write-here-your-answer"][language]}
            />
            <p className="text-xs text-gray-500 text-right">
              {feedback.length} / {minLength} {dictionary["minimum-characters"][language]}
            </p>
          </div>

          <button
            onClick={handleCancel}
            disabled={feedback.length < minLength}
            className={`w-full font-medium py-3 rounded-lg transition-colors ${
              feedback.length >= minLength
                ? "bg-gray-900 hover:bg-gray-800 text-white"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
          >
            {dictionary["continue"][language]}
          </button>
        </div>
      </div>
    </div>
  )
}
